// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"97":"41c74521","1500":"19da44d2","3835":"8ed329d8","4111":"41c74521"}[chunkId] + ".chunk.css";
};